module.exports = __webpack_public_path__ + "static/media/beaconManageUsers.cd64e76a.jpg";